export default __webpack_public_path__ + "static/Angel-1a4021c8c4fc825eadf0efc59bf29769.png";